// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3VXbB","Logo":"Toolbar_Logo__2k8BR","DesktopOnly":"Toolbar_DesktopOnly__3f4Q5"};